module.exports = __webpack_public_path__ + "static/media/SuisseIntl-Medium-WebS.5f5f23c3.ttf";